/*=============================================== InputCheckPage ===============================================*/

import { InputCheck, Flexbox } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { validationStatus } from "data"

const InputCheckPage = () => {
    const items: ItemType[] = [
        {
            title: "Radio",
            content: (
                <Flexbox gap="m" flexWrap="wrap">
                    <InputCheck
                        type="radio"
                        id="radio-1"
                        name="radio"
                        label="Radio"
                    />
                    <InputCheck
                        type="radio"
                        id="radio-2"
                        name="radio"
                        label="Radio"
                        defaultChecked
                    />

                    <InputCheck
                        type="radio"
                        id="radio-3"
                        name="radio-validation"
                        label="Radio"
                        validation="not-passed"
                    />
                    <InputCheck
                        type="radio"
                        id="radio-4"
                        name="radio-validation"
                        label="Radio"
                        validation="not-passed"
                        defaultChecked
                    />

                    <InputCheck
                        type="radio"
                        id="radio-5"
                        name="radio-disabled"
                        label="Radio"
                        disabled
                    />
                    <InputCheck
                        type="radio"
                        id="radio-6"
                        name="radio-disabled"
                        label="Radio"
                        disabled
                        defaultChecked
                    />
                </Flexbox>
            ),
            code: '<InputCheck type="radio" id="radio-1" name="radio" label="Radio" />\n<InputCheck type="radio" id="radio-2" name="radio" label="Radio" defaultChecked />\n\n<InputCheck type="radio" id="radio-3" name="radio-validation" label="Radio" validation="not-passed" />\n<InputCheck type="radio" id="radio-4" name="radio-validation" label="Radio" validation="not-passed" defaultChecked />\n\n<InputCheck type="radio" id="radio-5" name="radio-disabled" label="Radio" disabled />\n<InputCheck type="radio" id="radio-6" name="radio-disabled" label="Radio" disabled defaultChecked />',
        },
        {
            title: "Checkbox",
            content: (
                <Flexbox gap="m" flexWrap="wrap">
                    <InputCheck
                        type="checkbox"
                        id="checkbox-1"
                        name="checkbox"
                        label="Checkbox"
                    />
                    <InputCheck
                        type="checkbox"
                        id="checkbox-2"
                        name="checkbox"
                        label="Checkbox"
                        defaultChecked
                    />

                    <InputCheck
                        type="checkbox"
                        id="checkbox-3"
                        name="checkbox-validation"
                        label="Checkbox"
                        validation="not-passed"
                    />
                    <InputCheck
                        type="checkbox"
                        id="checkbox-4"
                        name="checkbox-validation"
                        label="Checkbox"
                        validation="not-passed"
                        defaultChecked
                    />

                    <InputCheck
                        type="checkbox"
                        id="checkbox-5"
                        name="checkbox-disabled"
                        label="Checkbox"
                        disabled
                    />
                    <InputCheck
                        type="checkbox"
                        id="checkbox-6"
                        name="checkbox-disabled"
                        label="Checkbox"
                        disabled
                        defaultChecked
                    />
                </Flexbox>
            ),
            code: '<InputCheck type="checkbox" id="checkbox-1" name="checkbox" label="Checkbox" />\n<InputCheck type="checkbox" id="checkbox-2" name="checkbox" label="Checkbox" defaultChecked />\n\n<InputCheck type="checkbox" id="checkbox-3" name="checkbox-validation" label="Checkbox" validation="not-passed" />\n<InputCheck type="checkbox" id="checkbox-4" name="checkbox-validation" label="Checkbox" validation="not-passed" defaultChecked />\n\n<InputCheck type="checkbox" id="checkbox-5" name="checkbox-disabled" label="Checkbox" disabled />\n<InputCheck type="checkbox" id="checkbox-6" name="checkbox-disabled" label="Checkbox" disabled defaultChecked />',
        },
        {
            title: "Radio tile",
            content: (
                <Flexbox gap="m" flexDirection="column">
                    <InputCheck
                        type="radio"
                        id="radio-tile-1"
                        name="radio-tile"
                        label="Radio tile"
                        variant="tile"
                    />
                    <InputCheck
                        type="radio"
                        id="radio-tile-2"
                        name="radio-tile"
                        label="Radio tile"
                        variant="tile"
                        defaultChecked
                    />

                    <InputCheck
                        type="radio"
                        id="radio-tile-3"
                        name="radio-tile-validation"
                        label="Radio tile"
                        validation="not-passed"
                        variant="tile"
                    />
                    <InputCheck
                        type="radio"
                        id="radio-tile-4"
                        name="radio-tile-validation"
                        label="Radio tile"
                        validation="not-passed"
                        variant="tile"
                        defaultChecked
                    />

                    <InputCheck
                        type="radio"
                        id="radio-tile-5"
                        name="radio-tile-disabled"
                        label="Radio tile"
                        variant="tile"
                        disabled
                    />
                    <InputCheck
                        type="radio"
                        id="radio-tile-6"
                        name="radio-tile-disabled"
                        label="Radio tile"
                        variant="tile"
                        disabled
                        defaultChecked
                    />
                </Flexbox>
            ),
            code: '<InputCheck type="radio" id="radio-tile-1" name="radio-tile" label="Radio tile" variant="tile" />\n<InputCheck type="radio" id="radio-tile-2" name="radio-tile" label="Radio tile" variant="tile" defaultChecked />\n\n<InputCheck type="radio" id="radio-tile-3" name="radio-tile-validation" label="Radio tile" validation="not-passed" variant="tile" />\n<InputCheck type="radio" id="radio-tile-4" name="radio-tile-validation" label="Radio tile" validation="not-passed" variant="tile" defaultChecked />\n\n<InputCheck type="radio" id="radio-tile-5" name="radio-tile-disabled" label="Radio tile" variant="tile" disabled />\n<InputCheck type="radio" id="radio-tile-6" name="radio-tile-disabled" label="Radio tile" variant="tile" disabled defaultChecked />',
        },
        {
            title: "Checkbox tile",
            content: (
                <Flexbox gap="m" flexDirection="column">
                    <InputCheck
                        type="checkbox"
                        id="checkbox-tile-1"
                        name="checkbox-tile"
                        label="Checkbox tile"
                        variant="tile"
                    />
                    <InputCheck
                        type="checkbox"
                        id="checkbox-tile-2"
                        name="checkbox-tile"
                        label="Checkbox tile"
                        variant="tile"
                        defaultChecked
                    />

                    <InputCheck
                        type="checkbox"
                        id="checkbox-tile-3"
                        name="checkbox-tile-validation"
                        label="Checkbox tile"
                        validation="not-passed"
                        variant="tile"
                    />
                    <InputCheck
                        type="checkbox"
                        id="checkbox-tile-4"
                        name="checkbox-tile-validation"
                        label="Checkbox tile"
                        validation="not-passed"
                        variant="tile"
                        defaultChecked
                    />

                    <InputCheck
                        type="checkbox"
                        id="checkbox-tile-5"
                        name="checkbox-tile-disabled"
                        label="Checkbox tile"
                        variant="tile"
                        disabled
                    />
                    <InputCheck
                        type="checkbox"
                        id="checkbox-tile-6"
                        name="checkbox-tile-disabled"
                        label="Checkbox tile"
                        variant="tile"
                        disabled
                        defaultChecked
                    />
                </Flexbox>
            ),
            code: '<InputCheck type="checkbox" id="checkbox-tile-1" name="checkbox-tile" label="Checkbox tile" variant="tile" />\n<InputCheck type="checkbox" id="checkbox-tile-2" name="checkbox-tile" label="Checkbox tile" variant="tile" defaultChecked />\n\n<InputCheck type="checkbox" id="checkbox-tile-3" name="checkbox-tile-validation" label="Checkbox tile" validation="not-passed" variant="tile" />\n<InputCheck type="checkbox" id="checkbox-tile-4" name="checkbox-tile-validation" label="Checkbox tile" validation="not-passed" variant="tile" defaultChecked />\n\n<InputCheck type="checkbox" id="checkbox-tile-5" name="checkbox-tile-disabled" label="Checkbox tile" variant="tile" disabled />\n<InputCheck type="checkbox" id="checkbox-tile-6" name="checkbox-tile-disabled" label="Checkbox tile" variant="tile" disabled defaultChecked />',
        },
        {
            title: "Toggle",
            content: (
                <Flexbox gap="m" flexWrap="wrap">
                    <InputCheck
                        type="checkbox"
                        id="checkbox-toggle-1"
                        name="checkbox-toggle"
                        label="Toggle"
                        variant="toggle"
                    />
                    <InputCheck
                        type="checkbox"
                        id="checkbox-toggle-2"
                        name="checkbox-toggle"
                        label="Toggle"
                        variant="toggle"
                        defaultChecked
                    />

                    <InputCheck
                        type="checkbox"
                        id="checkbox-toggle-3"
                        name="checkbox-toggle-validation"
                        label="Toggle"
                        validation="not-passed"
                        variant="toggle"
                    />
                    <InputCheck
                        type="checkbox"
                        id="checkbox-toggle-4"
                        name="checkbox-toggle-validation"
                        label="Toggle"
                        validation="not-passed"
                        variant="toggle"
                        defaultChecked
                    />

                    <InputCheck
                        type="checkbox"
                        id="checkbox-toggle-5"
                        name="checkbox-toggle-disabled"
                        label="Toggle"
                        variant="toggle"
                        disabled
                    />
                    <InputCheck
                        type="checkbox"
                        id="checkbox-toggle-6"
                        name="checkbox-toggle-disabled"
                        label="Toggle"
                        variant="toggle"
                        disabled
                        defaultChecked
                    />
                </Flexbox>
            ),
            code: '<InputCheck type="checkbox" id="checkbox-toggle-1" name="checkbox-toggle" label="Toggle" variant="toggle" />\n<InputCheck type="checkbox" id="checkbox-toggle-2" name="checkbox-toggle" label="Toggle" variant="toggle" defaultChecked />\n\n<InputCheck type="checkbox" id="checkbox-toggle-3" name="checkbox-toggle-validation" label="Toggle" validation="not-passed" variant="toggle" />\n<InputCheck type="checkbox" id="checkbox-toggle-4" name="checkbox-toggle-validation" label="Toggle" validation="not-passed" variant="toggle" defaultChecked />\n\n<InputCheck type="checkbox" id="checkbox-toggle-5" name="checkbox-toggle-disabled" label="Toggle" variant="toggle" disabled />\n<InputCheck type="checkbox" id="checkbox-toggle-6" name="checkbox-toggle-disabled" label="Toggle" variant="toggle" disabled defaultChecked />',
        },
        {
            title: "Selector",
            content: (
                <Flexbox gap="m" flexWrap="wrap">
                    <InputCheck
                        type="checkbox"
                        id="checkbox-selector-1"
                        name="checkbox-selector"
                        label="Selector"
                        variant="selector"
                    />
                    <InputCheck
                        type="checkbox"
                        id="checkbox-selector-2"
                        name="checkbox-selector"
                        label="Selector"
                        variant="selector"
                        defaultChecked
                    />

                    <InputCheck
                        type="checkbox"
                        id="checkbox-selector-3"
                        name="checkbox-selector-validation"
                        label="Selector"
                        validation="not-passed"
                        variant="selector"
                    />
                    <InputCheck
                        type="checkbox"
                        id="checkbox-selector-4"
                        name="checkbox-selector-validation"
                        label="Selector"
                        validation="not-passed"
                        variant="selector"
                        defaultChecked
                    />

                    <InputCheck
                        type="checkbox"
                        id="checkbox-selector-5"
                        name="checkbox-selector-disabled"
                        label="Selector"
                        variant="selector"
                        disabled
                    />
                    <InputCheck
                        type="checkbox"
                        id="checkbox-selector-6"
                        name="checkbox-selector-disabled"
                        label="Selector"
                        variant="selector"
                        disabled
                        defaultChecked
                    />
                </Flexbox>
            ),
            code: '<InputCheck type="checkbox" id="checkbox-selector-1" name="checkbox-selector" label="Selector" variant="selector" />\n<InputCheck type="checkbox" id="checkbox-selector-2" name="checkbox-selector" label="Selector" variant="selector" defaultChecked />\n\n<InputCheck type="checkbox" id="checkbox-selector-3" name="checkbox-selector-validation" label="Selector" validation="not-passed" variant="selector" />\n<InputCheck type="checkbox" id="checkbox-selector-4" name="checkbox-selector-validation" label="Selector" validation="not-passed" variant="selector" defaultChecked />\n\n<InputCheck type="checkbox" id="checkbox-selector-5" name="checkbox-selector-disabled" label="Selector" variant="selector" disabled />\n<InputCheck type="checkbox" id="checkbox-selector-6" name="checkbox-selector-disabled" label="Selector" variant="selector" disabled defaultChecked />',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "id",
            type: "string",
            required: true,
        },
        {
            subtitle: "label",
            type: "string",
            required: true,
        },
        {
            subtitle: "type",
            type: "string",
            possible: ["checkbox", "radio"],
            default: "radio",
        },
        {
            subtitle: "variant",
            type: "string",
            possible: ["tile", "toggle", "selector"],
        },
        validationStatus,
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default InputCheckPage
